import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  Card,
  Form,
  Table,
  Select,
  TimePicker,
  Typography
} from 'antd'
import './index.css'

const { Text } = Typography

class FlightAssignment extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  

  render() {
    const options = []
    for (let i = 10; i < 36; i++) {
      options.push({
        value: i.toString(36) + i,
        label: i.toString(36) + i,
      })
    }

    const data = [
      {
        key: 1,
        departure: '08DEC2025 10:00 AM',
        flight: '312',
        cityPair: 'MSP-HNL',
        subtext: '76K',
      },
      {
        key: 2,
        departure: '08DEC2025 10:15 AM',
        flight: '121',
        cityPair: 'MSP-HND',
        subtext: '35M',
      },
      {
        key: 3,
        departure: '08DEC2025 10:30 AM',
        flight: '389',
        cityPair: 'DTW-PVG',
        subtext: '359',
      },
      {
        key: 4,
        departure: '08DEC2025 10:45 AM',
        flight: '307',
        cityPair: 'DTW-HNL',
        subtext: '76K',
      },
      {
        key: 5,
        departure: '08DEC2025 12:40 PM',
        flight: '159',
        cityPair: 'DTW-ICN',
        subtext: '35H',
      },
      {
        key: 6,
        departure: '08DEC2025 1:30 PM',
        flight: '171',
        cityPair: 'MSP-ICN',
        subtext: '35M',
      },
      {
        key: 7,
        departure: '08DEC2025 1:55 PM',
        flight: '275',
        cityPair: 'DTW-HND',
        subtext: '359',
      },
      {
        key: 8,
        departure: '08DEC2025 3:45 PM',
        flight: '152',
        cityPair: 'MSP-CDG',
        subtext: '333',
      },
    ]

    const columns = [
      {
        title: 'Departure Date/Time (local)',
        dataIndex: 'departure',
        key: 'departure',
        sorter: (a, b) => new Date(a.departure) - new Date(b.departure),
      },
      {
        title: 'Flt #',
        dataIndex: 'flight',
        key: 'flight',
        align: 'center',
        sorter: (a, b) => a.flight - b.flight,
      },
      {
        title: 'City Pair',
        dataIndex: 'cityPair',
        key: 'cityPair',
        render: (text, record) => (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 500 }}>{text}</div>
            <Text type='secondary' style={{ fontSize: 12 }}>
              {record.subtext}
            </Text>
          </div>
        ),
      },
      {
        title: 'Assign Flight',
        key: 'assign',
        render: () => (
          <Select
            placeholder='Select'
            style={{ width: '100%' }}
            options={[
              {
                value: 'A',
                label: 'Option A' 
              },
              {
                value: 'B',
                label: 'Option B' 
              },
              {
                value: 'C',
                label: 'Option C' 
              },
            ]}
          />
        ),
      },
    ]

    return (
      <div>
        <Row gutter={[24, 24]}  className='contentrow-height'>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
            <Card
              title={'DoD Flight Assignments'}
              className='custom-card h-100'
            >
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
                  <Form
                    layout= 'vertical'
                    className='position-relative'
                  >
                    <Row gutter={[18, {
                      xs: 24,
                      lg: 0 
                    }]} className='mb-4'>
                      <Col xs={24} flex='1 0 24%' className='fields'>
                        <label>Station</label>
                        <Select
                          mode='multiple'
                          // size={size}
                          placeholder='Please select'
                          defaultValue={['a10', 'c12']}
                          // onChange={}
                          style={{ width: '100%' }}
                          options={options}
                        />
                          
                      </Col>
                      <Col xs={24} sm={10} md={8} className='fields'>
                        <label>Departure Date</label>
                        <TimePicker
                          //onChange={}
                          // value={}
                        />
                      </Col>
                      <Col className='text-center d-flex pl-0'>
                        <Button className='custom-button mb-2 mt-auto' size='small' type='primary'>Send Skd</Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                  <div className='table-outer'>
                    <Table
                      rowKey='id'
                      className='custom-table milestone-table w-100'
                      dataSource={data}
                      columns={columns}
                      pagination={false}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>  
        </Row>
      </div>
    )
  }
}

export default FlightAssignment
